import api from "./api";

// ============================
// Get Home Data
// ============================
export const getHome = async () => {
  const response = await api.get("/home");
  return response;
};

// ============================
// Get Home By ID
// ============================
export const getHomeById = async (id) => {
  const response = await api.get(`/home/${id}`);
  return response;
};

// ============================
// Create Home
// ============================
export const createHome = async (data) => {
  const response = await api.post("/home", data);
  return response;
};

// ============================
// Update Home
// ============================
export const updateHome = async (id, data) => {
  const response = await api.put(`/home/${id}`, data);
  return response;
};

// ============================
// Delete Home
// ============================
export const deleteHome = async (id) => {
  const response = await api.delete(`/home/${id}`);
  return response;
};